import {Button, Dialog} from '@wandb/components';
import React from 'react';
import {toast} from 'react-toastify';

import {extractErrorMessageFromApolloError} from '../../../util/errors';

export const DeleteCustomRoleModal = ({
  isOpen,
  close,
  name,
  inheritedFrom,
  onDelete,
}: {
  isOpen: boolean;
  close: () => void;
  name: string;
  inheritedFrom: string;
  onDelete: () => Promise<void>;
}) => {
  const handleClose = () => {
    close();
  };

  const handleDelete = async () => {
    try {
      await onDelete();
      toast.success('Successfully deleted role');
      close();
    } catch (err) {
      toast.error(extractErrorMessageFromApolloError(err));
    }
  };

  return (
    <Dialog.Alert
      isOpen={isOpen}
      onOpenChange={open => {
        if (!open) {
          handleClose();
        }
      }}>
      <Dialog.Heading>Delete custom role &quot;{name}&quot;?</Dialog.Heading>
      <Dialog.Content>
        Deleting this role will downgrade all assigned users and invites. These
        users will be re-assigned to the <b>{inheritedFrom}</b> role.
      </Dialog.Content>
      <Dialog.Footer>
        <Button variant="destructive" onPress={handleDelete}>
          Delete
        </Button>
        <Button variant="secondary" onPress={handleClose}>
          Cancel
        </Button>
      </Dialog.Footer>
    </Dialog.Alert>
  );
};
